import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";
import ApplicationSerializer from "./application";

export default class DatabaseSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  usesProxy = true;

  attrs = {
    project: "projectkey",
    instanceDatabases: { key: "databases", deserialize: "records", serialize: false },
    instanceUsers: { key: "users", deserialize: "records", serialize: false },
  };
}
